import { render } from "./WelcomeMessage.vue?vue&type=template&id=6a594113"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js"

import "./WelcomeMessage.vue?vue&type=style&index=0&id=6a594113&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__